import React, { useId } from 'react';
import styles from './RadioGroup.module.css';

export default function RadioGroup({ value, onChange, options = [] }) {
    const name = useId();

    return (
        <div className={styles.row} role="radiogroup">
            {options.map((o) => {
                const id = `${name}-${o.value}`;
                const checked = String(value) === String(o.value);
                return (
                    <label
                        key={o.value}
                        htmlFor={id}
                        className={`${styles.option} ${checked ? styles.checked : ''} ${o.disabled ? styles.disabled : ''}`}
                    >
                        <input
                            id={id}
                            type="radio"
                            name={name}
                            checked={checked}
                            disabled={o.disabled}
                            onChange={() => onChange(o.value)}
                            className={styles.input}
                        />
                        <span className={styles.control}>
                            <span className={styles.dot} />
                        </span>
                        <span className={styles.label}>{o.label}</span>
                    </label>
                );
            })}
        </div>
    );
}
